// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": function componentNodeModulesGatsbyPluginOfflineAppShellJs() {
    return import("./../gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-annual-report-js": function componentSrcPagesAnnualReportJs() {
    return import("./../../src/pages/annual-report.js"
    /* webpackChunkName: "component---src-pages-annual-report-js" */
    );
  },
  "component---src-pages-courses-js": function componentSrcPagesCoursesJs() {
    return import("./../../src/pages/courses.js"
    /* webpackChunkName: "component---src-pages-courses-js" */
    );
  },
  "component---src-pages-impact-forum-js": function componentSrcPagesImpactForumJs() {
    return import("./../../src/pages/impact-forum.js"
    /* webpackChunkName: "component---src-pages-impact-forum-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-innovation-js": function componentSrcPagesInnovationJs() {
    return import("./../../src/pages/innovation.js"
    /* webpackChunkName: "component---src-pages-innovation-js" */
    );
  },
  "component---src-pages-project-pool-js": function componentSrcPagesProjectPoolJs() {
    return import("./../../src/pages/project-pool.js"
    /* webpackChunkName: "component---src-pages-project-pool-js" */
    );
  },
  "component---src-pages-projects-js": function componentSrcPagesProjectsJs() {
    return import("./../../src/pages/projects.js"
    /* webpackChunkName: "component---src-pages-projects-js" */
    );
  },
  "component---src-pages-publications-js": function componentSrcPagesPublicationsJs() {
    return import("./../../src/pages/publications.js"
    /* webpackChunkName: "component---src-pages-publications-js" */
    );
  },
  "component---src-pages-students-corner-js": function componentSrcPagesStudentsCornerJs() {
    return import("./../../src/pages/students-corner.js"
    /* webpackChunkName: "component---src-pages-students-corner-js" */
    );
  },
  "component---src-templates-project-js": function componentSrcTemplatesProjectJs() {
    return import("./../../src/templates/project.js"
    /* webpackChunkName: "component---src-templates-project-js" */
    );
  }
};